module.exports = "/assets/landing-rw/instagram/insta-feed-2.jpg?wd3yoiX";